import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import axios from "axios";
import { isEmpty } from 'lodash';
import { 
    Flex, VStack, Input, Button, ButtonGroup, Text,
    InputGroup, InputRightElement, InputRightAddon, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center, Select,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableContainer, useDisclosure,
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css'
import { MdAddCircleOutline, MdDeleteForever, MdBlock, MdDisabledByDefault, MdEdit, MdSave, MdCancel } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';

import { FormattedDate, FormattedTime } from 'react-intl';
import { withNamespaces } from 'react-i18next';

import { SUCCESS_STATUS, FAILED_STATUS, ROLES, ERROR_CODES } from '../../../constants';
import "../../../styles/index.scss";

import { 
    apiLoadListUser, apiCreateNewUser, apiUpdateAUser, apiDeleteAUser
} from '../../../redux/apis/UserApis';
import { apiLoadListCompany } from '../../../redux/apis';
import { clearUserActionStatus } from '../../../redux/actions';
import { getUserList, getUserActionStatus, getUserActionMsg, getUserError, getCompanyList } from '../../../redux/selectors';

import NoDataPage from '../../../components/NoData';
import AddEditUserModal from '../Modals/AddEditUserModal';

function Users({ 
    userList, companyList, actionStatus, actionMsg, error, t,
    apiLoadListUser, apiCreateNewUser, apiUpdateAUser, apiDeleteAUser, clearUserActionStatus, apiLoadListCompany
}) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    
    const [ searchText, setSearchText ] = useState("");
    const [ isSearching, setIsSearching ] = useState(false);
    const [ isAction, setIsAction ] = useState(false);

    const mounted = useRef();

    const [ cookies ] = useCookies(["loginCookie"]);
    //const max_user_register = parseInt(cookies?.loginCookie?.data?.companyDetail?.max_user_register);

    useEffect(() => {
        if(!mounted.current) {
            if(cookies?.loginCookie?.data?.roles === 'super_admin') {
                apiLoadListUser({ all: true });
                apiLoadListCompany({ all: true, order_by: "name", order_dir: "asc" });
            } else {
                apiLoadListUser({ company_id: cookies?.loginCookie?.data?.company_id });
            }
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        } else {
            if(actionStatus === SUCCESS_STATUS) {
                // only close modal if create successful
                if(isOpen) {
                    onClose();
                }
                toast.success(actionMsg, {
                    position: "bottom-right"
                });
                clearUserActionStatus();
            } 
            else if(actionStatus === FAILED_STATUS) {         
                toast.error(error, {
                    position: "bottom-right"
                });
                clearUserActionStatus();
            }
        }
    });

    useEffect(() => {
        setIsSearching(false);
    }, [userList]);

    const handleAddNewUser = () => {
        onOpen();
    }

    const handleDeleteAUser = (user_id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn xoá tài khoản này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={() => {
                                    apiDeleteAUser({ 
                                        id: user_id, 
                                        payload: { 
                                            company_id: cookies?.loginCookie?.data?.company_id,
                                            user_id: cookies?.loginCookie?.data?.id,
                                            is_active: false 
                                        } 
                                    });
                                    onClose();
                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    const handleBlockUser = async(user_id, is_block) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>
                            Xác nhận <br />Bạn có muốn cấm tài khoản này không?
                        </h1>
                        <div>
                            <button onClick={onClose}>Huỷ</button>
                            <button
                                onClick={async() => {
                                    try
                                    {
                                        let res = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/users/${user_id}`, {
                                            is_block: !is_block
                                        }, {
                                            auth: {
                                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                                            }
                                        });
                                
                                        if(res.data?.status === 200) {
                                            toast.success(`Bạn đã ${is_block ? "bỏ cấm" : "cấm"} tài khoản thành công`, {
                                                position: "bottom-right"
                                            });
                                        } else {
                                            toast.error(`Bạn đã ${is_block ? "bỏ cấm" : "cấm"} tài khoản không thành công`, {
                                                position: "bottom-right"
                                            });
                                        }
                                    }
                                     catch(error) {
                                        if(error?.code) {
                                            toast.error(`${ERROR_CODES[error?.code]} (${error?.code})`, {
                                                position: "bottom-right"
                                            });
                                        }
                                    }
                                    onClose();

                                }}
                                className='yes'
                            >
                                Đồng Ý
                            </button>
                        </div>
                    </div>
                )
            },
            closeOnClickOutside: false
        })
    }

    // console.log("--- userList", userList)

    return (
        <React.Fragment>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderBottomWidth="2px" px={4} py={2} gap={2} justify="space-between">
                {
                    // (((max_user_register - userList.length) > 0) || isSuperAdmin) &&
                    <Button colorScheme='orange' isDisabled={!isAction} onClick={handleAddNewUser}>
                        <Icon boxSize={6} as={MdAddCircleOutline} marginRight="8px"/>   
                        <Text fontSize="14px" fontWeight="400" textTransform="uppercase">{t("Add")}</Text>
                    </Button>
                }
                <InputGroup width={{base: "100%", md: "40%", lg: "40%"}}>
                    <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} onKeyUp={(evt) => {
                        if(evt.key === "Enter") {
                            setIsSearching(true);
                            setTimeout(() => {
                                if(cookies?.loginCookie?.data?.roles === 'super_admin') {
                                    apiLoadListUser({ all: true, searchText });
                                } else {
                                    apiLoadListUser({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                }
                            }, 500);
                        }
                    }}/>
                    <InputRightAddon p={0}>
                        <Button colorScheme='blue' 
                            isLoading={isSearching}
                            loadingText={t("Searching")}
                            onClick={() => {
                                setIsSearching(true);
                                setTimeout(() => {
                                    if(cookies?.loginCookie?.data?.roles === 'super_admin') {
                                        apiLoadListUser({ all: true, searchText });
                                    } else {
                                        apiLoadListUser({ searchText, company_id: cookies?.loginCookie?.data?.company_id });
                                    }
                                }, 500);
                            }
                        }>
                            {t("Search")}
                        </Button>
                    </InputRightAddon>
                </InputGroup>
            </Flex>
            
            <PaginatedItems items={userList} itemsPerPage={10} isAction={isAction} userList={userList} t={t}
                handleDeleteAUser={handleDeleteAUser} handleBlockUser={handleBlockUser}
                apiUpdateAUser={apiUpdateAUser}
            />

            {
                !(userList && userList.length > 0) &&
                <NoDataPage  text="Hiện tại không có dữ liệu"/>
            }

            {  
                isOpen &&
                <AddEditUserModal 
                    initialRef={initialRef} isOpen={isOpen} onClose={onClose}
                    company_id={cookies?.loginCookie?.data?.company_id} companyList={companyList} actionStatus={actionStatus}
                    apiCreateNewUser={apiCreateNewUser}
                />
            }
            <ToastContainer />
        </React.Fragment>
    )
}

function PaginatedItems({ items, itemsPerPage, isAction, userList, handleDeleteAUser, handleBlockUser, apiUpdateAUser, t }) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ editedRoleUserId, setEditedRoleUserId ] = useState(0);
    const [ editedRole, setEditedRole ] = useState("");
    const [ itemOffset, setItemOffset ] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = items.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(items.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % items.length;
        setItemOffset(newOffset);
    } 

    useEffect(() => {
        setEditedRoleUserId(0);
        setEditedRole("");
    }, [userList]);

    return (
        <>
           <TableContainer width="100%" px="20px" py="5px">
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr bg="#EAF0F0">
                            <Th>{t("Index")}</Th>    
                            <Th>{t("Company")}</Th>
                            <Th>{t("Full_Name")}</Th>
                            <Th>{t("Portrait")}</Th>
                            <Th>{t("Phone")}</Th>
                            <Th>{t("Email")}</Th>
                            <Th>{t("Authorize")}</Th>
                            <Th>{t("Status")}</Th>
                            <Th>{t("Created_At")}</Th>
                            <Th>{t("Edited_At")}</Th>
                            <Th isNumeric></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            currentItems && currentItems.map((item, idx) => {
                                return (
                                    <Tr key={item.id} style={{ textDecoration: item.is_block ? "line-through" : "" }}>
                                        <Td>
                                            <Text fontWeight="600">{itemOffset + idx + 1}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600" color="blue">{item?.companyDetail?.name}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600" color="#e65100">{item.full_name}</Text>
                                        </Td>
                                        <Td>
                                            {
                                                item.portrait_url &&
                                                <Image alt="user_image" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/users/${item.portrait_url}`} width="50px" height="50px"/>
                                            }
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.phone}</Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">{item.email}</Text>
                                        </Td>
                                        <Td>
                                            <VStack>
                                                {
                                                    editedRoleUserId !== item.id && 
                                                    <>
                                                        <Text fontWeight="600">{ROLES[item.roles]}</Text>

                                                        {
                                                            (cookies.loginCookie?.data?.id !== item.id) &&
                                                            <Button colorScheme='teal' size="sm" isDisabled={!isAction}
                                                                onClick={
                                                                    () => {
                                                                        setEditedRoleUserId(item.id);
                                                                        setEditedRole(item.roles);
                                                                    }
                                                                }
                                                            >
                                                                <Icon boxSize={4} as={MdEdit} marginRight="2px"/> 
                                                                <Text fontSize="14px">
                                                                    {t("Update")}
                                                                </Text>
                                                            </Button>
                                                        }
                                                    </>
                                                }
                                                {
                                                    editedRoleUserId === item.id && 
                                                    <>
                                                        <Select value={editedRole} placeholder='Chọn Quyền'
                                                            onChange={(evt) => setEditedRole(evt.currentTarget.value)}
                                                        >
                                                            {
                                                                Object.keys(ROLES).map(key => (
                                                                    <React.Fragment key={key}>
                                                                        <option value={key}>{ROLES[key]}</option>
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </Select>

                                                        <Flex gap={2}>
                                                            <Button colorScheme='red'
                                                                onClick={
                                                                    () => {
                                                                        setEditedRoleUserId(0);
                                                                    }
                                                                }
                                                            >
                                                                <Icon boxSize={4} as={MdCancel} marginRight="2px"/>   
                                                                <Text fontSize="14px">{t("Cancel")}</Text>
                                                            </Button>
                                                            <Button colorScheme='blue' 
                                                                onClick={
                                                                    () => {
                                                                        apiUpdateAUser({
                                                                            id: item.id,
                                                                            payload: {
                                                                                roles: editedRole
                                                                            }
                                                                        })
                                                                    }
                                                                }
                                                            >
                                                                <Icon boxSize={4} as={MdSave} marginRight="2px"/>   
                                                                <Text fontSize="14px">{t("Save")}</Text>
                                                            </Button>
                                                        </Flex>
                                                    </>
                                                }
                                            </VStack>

                                        </Td>
                                        <Td>
                                            <Text fontWeight="600" color="red">
                                                { item.is_block ? "TÀI KHOẢN BỊ CẤM" : "" }
                                            </Text>
                                        </Td>
                                        <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                            </Text>  
                                        </Td>
                                        <Td>
                                            {
                                                item.updated_at &&
                                                <Text fontWeight="600">
                                                    <FormattedDate value={item.updated_at} /> <FormattedTime value={item.updated_at} />
                                                </Text>
                                            }
                                        </Td>
                                        <Td isNumeric>
                                            {/* {
                                                (cookies.loginCookie?.data?.id !== item.id) && */}
                                                <Flex direction="row" alignContent="center" gap={1}>
                                                    <Button colorScheme='orange' isDisabled={!isAction}
                                                        onClick={
                                                            () => handleBlockUser(item.id, item.is_block)
                                                        }
                                                    >
                                                        <Icon boxSize={4} as={MdDisabledByDefault} marginRight="2px"/>   
                                                        <Text fontSize="14px">{t("Block")}</Text>
                                                    </Button>

                                                    <Button colorScheme='red' isDisabled={!isAction}
                                                        onClick={() => handleDeleteAUser(item.id)}
                                                    >
                                                        <Icon boxSize={4} as={MdDeleteForever} marginRight="2px"/>   
                                                        <Text fontSize="14px">{t("Delete")}</Text>
                                                    </Button>
                                                </Flex>
                                            {/* } */}
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>
            
            {/* <Flex w="100%" justify="center" my="10px" position={{base: "relative", md: "fixed", lg: "fixed"}} bottom="0px"> */}
                <ReactPaginate 
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowLeftCircle} />
                        </Center>
                    }
                    nextLabel={
                        <Center>
                            <Icon boxSize={8} as={BsArrowRightCircle} />
                        </Center>
                    }
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageClassName='page-item'
                    activeClassName='active'
                    previousClassName='previous-item'
                    nextClassName='next-item'
                />
            {/* </Flex> */}
        </>
    )
}

const mapStateToProps = (state) => {
    const userList           =   getUserList(state);
    const companyList        =   getCompanyList(state);
    const actionStatus       =   getUserActionStatus(state);
    const actionMsg          =   getUserActionMsg(state);
    const error              =   getUserError(state);

    return { userList, companyList, actionStatus, actionMsg, error };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListUser:        payload => dispatch(apiLoadListUser(payload)),
    apiCreateNewUser:       payload => dispatch(apiCreateNewUser(payload)),
    apiUpdateAUser:         payload => dispatch(apiUpdateAUser(payload)),
    apiDeleteAUser:         payload => dispatch(apiDeleteAUser(payload)),
    apiLoadListCompany:     payload => dispatch(apiLoadListCompany(payload)),

    clearUserActionStatus:  payload => dispatch(clearUserActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Users));